import ContentLoader from '@space-core/components/contentLoader'
import { customMedia } from '@space-core/styles'

import CardContentLoader from '@space-shell/common/components/card/learningTrack/contentLoader'

import { ShowcaseOrientation } from '@space-shell/common/services/membership'
import { SectionType } from '@space-shell/common/services/sections'
import { ERROR_CONTENT_LOADER_AMOUNT } from '@space-shell/modules/products/components/productCard/constants'

import styled from 'styled-components'

const Container = styled.div`
  display: grid;
`

const Scroll = styled.div<{ $isModule: boolean }>`
  display: grid;
  grid-gap: var(--spacer-4);
  grid-template-columns: repeat(6, 12rem);

  ${({ $isModule }) => customMedia.greaterThan('sm')`
    grid-template-columns: ${$isModule ? `repeat(6, 11rem)` : `repeat(6, 16rem)`};
  `};

  ${({ $isModule }) => customMedia.greaterThan('md')`
    grid-template-columns: ${$isModule ? `repeat(6, 12rem)` : `repeat(6, 17rem)`};
  `};

  ${({ $isModule }) => customMedia.greaterThan('lg')`
    grid-template-columns: ${$isModule ? `repeat(6, 14rem)` : `repeat(6, 19rem)`};
  `};

  overflow-x: scroll;

  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-color: transparent transparent;

  ::-webkit-scrollbar {
    display: none;
  }

  ::-moz-scrollbar {
    display: none;
  }
`

export type LoaderListProps = {
  orientation: ShowcaseOrientation
  sectionType?: SectionType
  title?: boolean
  isPreview?: boolean
}

const TitleLoader = styled(ContentLoader)`
  width: 45%;

  ${customMedia.greaterThan('md')`
     width: 30%;
  `}

  ${customMedia.greaterThan('lg')`
    width: 20%;
  `}
`

const TitleLoaderNoAnimation = styled.div`
  width: 90%;
  height: var(--spacer-4);
  margin-top: -1rem;

  ${customMedia.greaterThan('md')`
     width: 60%;
  `}

  ${customMedia.greaterThan('lg')`
    width: 40%;
  `}
`

const LoaderList = ({
  orientation,
  title = false,
  sectionType = SectionType.PRODUCT,
  isPreview = false
}: LoaderListProps) => {
  const customOrientation =
    sectionType === SectionType.MODULE
      ? ShowcaseOrientation.HORIZONTAL
      : orientation || ShowcaseOrientation.VERTICAL

  return (
    <div data-test='section-loader'>
      {isPreview
        ? title && (
            <TitleLoaderNoAnimation className='_mb-5 _rounded _bg-gray-200 _ml-10 _mx-md-10' />
          )
        : title && <TitleLoader className='_mb-5 _rounded _px-md-10' />}
      <Container className='_overflow-hidden _position-relative _pl-4 _pl-md-10'>
        <Scroll className='_overflow-hidden' $isModule={sectionType === SectionType.MODULE}>
          {Array.from({ length: ERROR_CONTENT_LOADER_AMOUNT }).map((_, index) => (
            <CardContentLoader
              isPreview={isPreview}
              key={index.toString()}
              orientation={customOrientation}
              sectionType={sectionType}
            />
          ))}
        </Scroll>
      </Container>
    </div>
  )
}

export default LoaderList
